import React from "react";
import { Card, Text } from "@mantine/core";
import descriptionStyles from "./JobDescriptions.module.scss";
import { JobListing } from "@lib/types/jobTypes";
import SectionHeading from "../Various/SectionHeading";
import stripHtmlTags from "@lib/utils/string/stripHtmlTags";

function JobDescription({
  title,
  description,
}: {
  title: string;
  description?: string;
}) {
  if (!description || stripHtmlTags(description).trim().length === 0)
    return null;

  return (
    <>
      <SectionHeading>{title}</SectionHeading>
      <div className={descriptionStyles.description}>
        <Text mt="xs">
          <span
            dangerouslySetInnerHTML={{
              __html: description,
            }}
          ></span>
        </Text>
      </div>
    </>
  );
}

function JobDescriptions({ job }: { job: JobListing }) {
  return (
    <Card.Section className="p-2">
      <JobDescription title="Über den Job:" description={job.description} />
      <JobDescription
        title="Das bringen Sie mit:"
        description={job.qualifications}
      />
      <JobDescription
        title="Diese Benefits liefert die Firma:"
        description={job.benefits}
      />
      <JobDescription
        title="Finale Worte:"
        description={job.final_description}
      />
    </Card.Section>
  );
}

export default JobDescriptions;
